import { NgFor } from '@angular/common'
import { Component, input } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjChartModule } from '@grapecity/wijmo.angular2.chart'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { BaseComponent, ListItem } from '../../../shared'
import { AutoSizeDirective } from '../../../shared/utility/auto-size.directive'

@Component({
    selector: 'app-cost-changes',
    templateUrl: './cost-changes.component.html',
    styleUrls: ['./cost-changes.component.css'],
    standalone: true,
    imports: [FormsModule, WjInputModule, WjChartModule, AutoSizeDirective, NgFor],
})
export class CostChangesComponent extends BaseComponent {
    active = input(0)
    activeJobsMap = input<ListItem<string>[]>([])

    costChangesChartData: any

    refresh() {
        const requestDto = {
            jobs: this.activeJobsMap()
                .filter(x => x.selected)
                .map(x => x.value),
        }
        this.cancelableRequest(
            'Costs',
            true,
            this.services.data.load(true, true, this.services.data.post('/api/Projections/GetCostChangesData', requestDto)).subscribe({
                next: result => {
                    this.costChangesChartData = result[0]
                },
            }),
        )
    }
}
